module.exports = __webpack_public_path__ + "img/Stab_Vw.9e7cf3e4.svg";